import ScrollReveal from 'scrollreveal';
import parallax from 'jquery-parallax.js';

ScrollReveal().reveal('.reveal', { delay: 500, distance: '50px', duration: 1000, mobile: false });
ScrollReveal().reveal('.reveal-left', { delay: 600, distance: '50px', origin: 'left', duration: 1000, mobile: false });
ScrollReveal().reveal('.reveal-right', { delay: 700, distance: '50px', origin: 'right', duration: 1000, mobile: false });
ScrollReveal().reveal('.reveal-bottom', { delay: 800, distance: '50px', origin: 'bottom', duration: 1000, mobile: false });
ScrollReveal().reveal('.reveal-top', { delay: 600, distance: '50px', origin: 'top', duration: 1000, mobile: false });

function addDeleteForms() {
    $('a[data-method=destroy]').append(function () {
        if (!$(this).find('form').length > 0) {
            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                "<input type='hidden' name='_method' value='" + $(this).attr('delete') + "'>\n" +
                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                '</form>\n';
        } else { return '' }
    })
    .attr('href', '#')
    .attr('style', 'cursor:pointer;')
    .attr('onclick', '$(this).find("form").submit();');
}
addDeleteForms();

setTimeout(function() {
    $('.alert-disappear').fadeOut(3000);
}, 5000);

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $(".navbar").removeClass("enlarge");
    } else {
        $(".navbar").addClass("enlarge");
    }
});

$(".validate").validate({
    submitHandler: function(form) {
        // maybe disabling submit button
        $(form).find('button').prop('disabled', true);
        var btnText = $(form).find(':submit').text();
        $(form).find(':submit').text('Submitting...');
        var formData = $(form).serialize();

        $.ajax({
            type: "POST",
            url: $(form).attr('action'),
            data: formData,
            dataType: "json",
            success: (data) => {
                 if(data.success) {
                     $(form).find(':submit').text('Completing...');
                     $(form).find('.alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                     $(form).find('.alert span').text(data.message);    
                    if(data.redirect) {
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 2000);
                    }else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                 }
             },
             error: (data) => {
                 console.log(data);
                 $(form).find(':submit').prop('disabled', false);
                 $(form).find(':submit').text(btnText);
                 $(form).find('.alert').removeClass('d-none');
                 $(form).find('.alert span').text(data.responseJSON.message);
            }
        });
    }
});

$(".validate2").validate({
    submitHandler: function(form) {
        // maybe disabling submit button
        $(form).find('button').prop('disabled', true);
        var btnText = $(form).find(':submit').text();
        $(form).find(':submit').text('Submitting...');
        var formData = $(form).serialize();

        $.ajax({
            type: "POST",
            url: $(form).attr('action'),
            data: formData,
            dataType: "json",
            success: (data) => {
                 if(data.success) {
                     $(form).find(':submit').text('Completing...');
                     $(form).find('.alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                     $(form).find('.alert span').text(data.message);    
                    if(data.redirect) {
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 2000);
                    }else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                 }
             },
             error: (data) => {
                 console.log(data);
                 $(form).find(':submit').prop('disabled', false);
                 $(form).find(':submit').text(btnText);
                 $('.validate2 .alert').removeClass('d-none');
                 $('.validate2 .alert span').text(data.responseJSON.message);
            }
        });
    }
});

$(".validate3").validate({
    submitHandler: function(form) {
        // maybe disabling submit button
        $(form).find('button').prop('disabled', true);
        var btnText = $(form).find(':submit').text();
        $(form).find(':submit').text('Submitting...');
        var formData = $(form).serialize();

        $.ajax({
            type: "POST",
            url: $(form).attr('action'),
            data: formData,
            dataType: "json",
            success: (data) => {
                 if(data.success) {
                     $(form).find(':submit').text('Completing...');
                     $(form).find('.alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                     $(form).find('.alert span').text(data.message);    
                    if(data.redirect) {
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 2000);
                    }else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                 }
             },
             error: (data) => {
                 console.log(data);
                 $(form).find(':submit').prop('disabled', false);
                 $(form).find(':submit').text(btnText);
                 $('.validate3 .alert').removeClass('d-none');
                 $('.validate3 .alert span').text(data.responseJSON.message);
            }
        });
    }
});

$(".validate_upload").validate({
    submitHandler: function(form) {
        // maybe disabling submit button
        $(form).find('button').prop('disabled', true);
        var btnText = $(form).find(':submit').text();
        $(form).find(':submit').text('Submitting...');
        var formData = new FormData(form);

        $.ajax({
            type: "POST",
            url: $(form).attr('action'),
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: (data) => {
                if(data.success) {
                    $(form).find(':submit').text('Completing...');
                    $(form).find('.alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                    $(form).find('.alert span').text(data.message);    
                    if(data.redirect) {
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 2000);
                    }else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                }
            },
            error: (data) => {
                console.log(data);
                $(form).find(':submit').prop('disabled', false);
                $(form).find(':submit').text(btnText);
                $(form).find('.alert').removeClass('d-none');
                $(form).find('.alert span').text(data.responseJSON.message);
            }
        });
    }    
        
});

$(".validatedelete").validate({
    submitHandler: function(form) {
        // maybe disabling submit button
        $('.validatedelete button').prop('disabled', true);
        var btnText = $('.validatedelete button[type=submit]').text();
        $('.validatedelete button[type=submit]').text('Submitting...');
        var formData = $(form).serialize();

        $.ajax({
            type: "POST",
            url: $(form).attr('action'),
            data: formData,
            dataType: "json",
            success: (data) => {
                if(data.success) {
                    $('.validatedelete button[type=submit]').html('Completing...');
                    $('.validatedelete .alert').removeClass('d-none').removeClass('alert-danger').addClass('alert-success');
                    $('.validatedelete .alert span').text(data.message);    
                    if(data.redirect) {
                        setTimeout(() => {
                            window.location = data.redirect;
                        }, 500);
                    }else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    }
                }
            },
            error: (data) => {
                console.log(data);
                $('.validatedelete button').prop('disabled', false);
                $('.validatedelete button[type=submit]').text(btnText);
                $('.validatedelete .alert').removeClass('d-none');
                $('.validatedelete .alert span').text(data.responseJSON.message);
            }
        });
    }
});


$('.validatevote').each(function() {   // <- selects every <form> on page
    $(this).validate({
        submitHandler: function(form) {
            // maybe disabling submit button
            $(form).find("button[type=submit]").prop('disabled', true);
            $(form).find("button[type=submit]").text('Submitting...');
            var formData = $(form).serialize();

            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: formData,
                dataType: "json",
                success: (data) => {
                    // maybe enabling submit button
                    setTimeout(() => {
                        $(form).find("button[type=submit]").text('Voted');
                    }, 500);
                }
            });
        }
    });
});

// add class to radio button on click
$('.validatevote .form-check').on('click', function() {
    //$('.validatevote .form-check').removeClass('voted');
    //$(this).addClass('voted');
});

$('#editNomination').on('show.bs.modal', function(e) {
    const id = e.relatedTarget.dataset.id;
    let endpoint = `/nominations/${id}`;
    $('#editNomination .textwrapper').html('');
    axios.get(endpoint).then(response => {
        console.log(response.data);
        let status = document.querySelector('#editNomination input[name=status]');
        response.data.status_id == 1 ? status.checked = true : status.checked = false;
        let image = document.querySelector('#editNomination .cover img');
        let text = `<h4>${response.data.name}</h4><p>${response.data.description.substr(0, 160)}...</p>`
        $(image).attr('src', response.data.image || 'https://via.placeholder.com/300');
        $('#editNomination a').attr('href', `/nominations/${response.data.uuid}/edit`);
        $('#editNomination form').attr('action', `/nominations/${response.data.uuid}/status`);
        $('#editNomination .textwrapper').html(text);
    });
});


$(document).ready(function() {
    var endpoint = jQuery('a[data-method=destroy]').attr('href');
    $('a[data-method=destroy]').attr('href', '#');

    $('a[data-method=destroy]').on('click', function() {
        var redirect = $(this).attr('data-redirect');
        // fire the sweet alert
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(endpoint).then(function(response) {
                    console.log(response)
                    Swal.fire({
                        title: "Deleted!",
                        text: response.data.message
                    }).then((res) => {
                        if(redirect && redirect === 'yes'){
                            window.location = response.data.redirect;
                        }else{
                            window.location.reload();
                        }
                    });
                });
            }
        })
    });
});

$(document).ready(function() {
    var endpoint = jQuery('a[data-method=copy]').attr('href');
    $('a[data-method=copy]').attr('href', '#');

    $('a[data-method=copy]').on('click', function() {
        var redirect = $(this).attr('data-redirect');
        // fire the sweet alert
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, create copy!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(endpoint).then(function(response) {
                    console.log(response)
                    Swal.fire({
                        title: "Record copied!",
                        text: response.data.message
                    }).then((res) => {
                        if(redirect && redirect === 'yes'){
                            window.location = response.data.redirect;
                        }else{
                            window.location.reload();
                        }
                    });
                });
            }
        })
    });
});

$('a[data-confirm]').on('click', function() {
    var id = $(this).attr('data-confirm');
    var text = $(this).text();
    var item = $(this);
    var endpoint = window.location.origin + '/backend/users/' + id + '/confirm';

    $.ajax({
        type: "POST",
        url: endpoint,
        data: { _token: $('meta[name="csrf-token"]').attr('content') },
        dataType: "json",
        success: function (response) {
            console.log(response, 'response')
            if(response.success) {
                text = response.data ? 'Yes' : 'No';
                response.data ? item.removeClass('bg-secondary').addClass('bg-info') : item.removeClass('bg-info').addClass('bg-secondary');
                item.text(text);
            }
        }
    });
    
});


// Make record approved or pending
$('a[data-approve]').on('click', function() {
    var id = $(this).attr('data-approve');
    var text = $(this).text();
    var item = $(this);
    var endpoint = window.location.origin + '/nominations/'+ id +'/approve';

    $.ajax({
        type: "POST",
        url: endpoint,
        data: { _token: $('meta[name="csrf-token"]').attr('content') },
        dataType: "json",
        success: function (response) {
            console.log(response, 'response')
            if(response.success) {
                text = response.data === 1 ? 'Approved' : 'Pending';
                response.data === 1 ? item.removeClass('bg-danger').addClass('bg-success') : item.removeClass('bg-success').addClass('bg-danger');
                item.text(text);
            }
        }
    });
    
});


$(document).ready(function($) {
    let getDate = $('[data-date]').data('date');
    moment.utc(getDate, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm:ss');
    let date = moment(getDate, 'YYYY-MM-DD hh:mm:ss').format('YYYY/MM/DD hh:mm:ss');

    $('.countdown-timer').countdown(date).on('update.countdown', function(event) {
        var $this = $(this).html(event.strftime(''
            + '<span class="time"><span>%D</span> day%!d</span>'
            + '<span class="time"><span>%H</span> hr</span>'
            + '<span class="time"><span>%M</span> min</span>'
            + '<span class="time"><span>%S</span> sec</span>'));
    });
});

// File Upload Preview Plugin
$('.fileuploader button[type=submit]').addClass('disabled');

var readURL = function(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('.profile-pic').attr('src', e.target.result);
        }

        reader.readAsDataURL(input.files[0]);
    }
}

$(".file-upload").on('change', function(){
    readURL(this);
    console.log(this.files[0])
    $('.fileuploader button[type=submit]').removeClass('disabled');
});

$(".upload-button").on('click', function() {
   $(".file-upload").click();
});

$('.fileuploader button[type=submit]').on('click', function() {
    $('.fileuploader button[type=submit]').addClass('disabled');
    $('.fileuploader button[type=submit]').text('Uploading...');
});

$(".regular").submit(function () {
    $('.regular button[type=submit]').addClass('disabled');
    $('.regular button[type=submit]').text('Processing...');
});